import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectActDivisionAvailableColumns, getDefectActSignerCompanies, getServiceOrgs } from './api';

export const path = '/defect-act-division/list';

const PageDefectActDivisionList: React.FC = (props) => {
  const DefectActDivision = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDefectActDivisionAvailableColumns,
      serviceOrgs: getServiceOrgs,
      signerCompanies: getDefectActSignerCompanies,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DefectActDivision {...props} />;
};

export default PageDefectActDivisionList;
